export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_DECREASE_ITEM = "CART_DECREASE_ITEM";
export const CART_RESET = "CART_RESET";
export const CART_INCREASE_ITEM = "CART_INCREASE_ITEM";
